<template>
  <InvoiceParameterDefaultModal
    title="Regra criada com sucesso"
    width="440"
    :show="show"
    @close="setShowRuleCreatedModal(false)">
    <template slot="body">
      <div
        class="d-flex flex-row gap-h-10">
        <v-icon color="success">far fa-check-circle</v-icon>
        <TextBase>Regra configurada e salva com sucesso.</TextBase>
      </div>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-center gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="setShowRuleCreatedModal(false)">
          Ok
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
import { mapMutations } from 'vuex';
export default {
  name: "RuleCreatedModal",
  components: {
    InvoiceParameterDefaultModal,
    TextBase: InvoiceParameterText,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  methods: {
    ...mapMutations({
      setShowRuleCreatedModal: 'invoice-parameter/setShowRuleCreatedModal',
    }),
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>